import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderOneMain from "../components/UI/HeaderOneMain";
import BreadcrumbMain from "../components/UI/BreadcrumbMain";
import FooterOneMain from "../components/UI/FooterOneMain";
import BottomFooter from "../components/UI/BottomFooterMain";
import ShippingOneMain from "../components/UI/ShippingOneMain";
import PaymentMain from "../components/UI/PaymentMain";
import ScrollToTop from "react-scroll-to-top";

const CheckoutPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneMain category={true} />

      {/* Breadcrumb */}
      <BreadcrumbMain title={"Checkout"} />

      {/* Checkout */}
      <PaymentMain />

      {/* ShippingOne */}
      <ShippingOneMain />

      {/* FooterTwo */}
      <FooterOneMain />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default CheckoutPage;
